import { render, staticRenderFns } from "./DrawingBoard.vue?vue&type=template&id=7ee60cda&scoped=true"
import script from "./DrawingBoard.vue?vue&type=script&lang=js"
export * from "./DrawingBoard.vue?vue&type=script&lang=js"
import style0 from "./DrawingBoard.vue?vue&type=style&index=0&id=7ee60cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee60cda",
  null
  
)

export default component.exports